function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}
// Function to close all other open <details> elements except the current one
function closeAllOtherDetails(currentDetails = null) {
  document.querySelectorAll('[id^="Details-"]').forEach((detail) => {
    // If the detail is open and it's not the current one, close it
    if (detail.hasAttribute("open") && detail !== currentDetails) {
      // Clear any pending close timeout for the detail being closed
      if (detail.closeTimeout) {
        clearTimeout(detail.closeTimeout);
      }
      detail.removeAttribute("open");
      detail.querySelector("summary")?.setAttribute("aria-expanded", "false");
    }
  });
}

// Event listener for clicks anywhere on the document to close details
document.addEventListener("click", (event) => {
  // Check if the click target is outside any <details> element
  let clickedInsideDetails = false;
  document.querySelectorAll('[id^="Details-"]').forEach((detail) => {
    if (detail.contains(event.target)) {
      clickedInsideDetails = true;
    }
  });

  // If the click was outside all <details> elements, close all of them
  if (!clickedInsideDetails) {
    closeAllOtherDetails();
  }
});

// Iterate over each <details> element
// Define the onKeyUpEscape function, as it's used in both branches
function onKeyUpEscape(event) {
  if (event.key === "Escape") {
    const detailsElement = event.target.closest("details");
    if (detailsElement) {
      detailsElement.removeAttribute("open");
      // Find the summary within the details to update aria-expanded
      detailsElement.querySelector("summary")?.setAttribute("aria-expanded", "false");
    }
  }
}

function closeAllOtherDetails(currentDetails) {
  document.querySelectorAll('[id^="Details-"][open]').forEach((detail) => {
    if (detail !== currentDetails) {
      detail.removeAttribute("open");
      detail.querySelector("summary")?.setAttribute("aria-expanded", "false");
    }
  });
}
// Check if the screen width is greater than or equal to 1024px (considered "web" in your context)
if (window.matchMedia('(min-width: 757px)').matches) {
  // --- WEB CODE ---
  document.querySelectorAll('[id^="Details-"]').forEach((details) => {
    const summary = details.querySelector("summary");
   

    // Set ARIA attributes for accessibility
    if(summary){

      summary.setAttribute("role", "button");
      summary.setAttribute(
        "aria-expanded",
        details.hasAttribute("open") // Initial state
      );
      
      if (summary.nextElementSibling?.getAttribute("id")) {
        summary.setAttribute("aria-controls", summary.nextElementSibling.id);
      }
      
      // 🔗 Click to redirect (desktop only)
      summary.addEventListener("click", (event) => {
        const hasChildren = details.querySelector('.sub-menu, [id^="Details-"] details');
        const url = summary.dataset.url;

        // Only redirect if it's a top-level link with no dropdown
        if (url && !details.querySelector('.sub-menu')) {
          // Use a real anchor navigation instead of window.location.href
          const a = document.createElement('a');
          a.href = url;
          a.click();
          return;
        }

        event.preventDefault();
      });

    // 🟨 Hover logic on entire <details>
    details.addEventListener("mouseenter", () => {
      // Clear any pending close timeout if the mouse re-enters
      if (details.closeTimeout) {
        clearTimeout(details.closeTimeout);
      }

      // Close any other open details first
      closeAllOtherDetails(details);

      // Open the current details if it's not already open
      if (!details.hasAttribute("open")) {
        details.setAttribute("open", "");
        summary.setAttribute("aria-expanded", "true");
      }
    });

    // 🟨 Mouseleave logic with a timer to prevent immediate closing
    details.addEventListener("mouseleave", () => {
      // Set a timeout to close the details after a short delay (e.g., 200ms)
      details.closeTimeout = setTimeout(() => {
        if (details.hasAttribute("open")) {
          details.removeAttribute("open");
          summary.setAttribute("aria-expanded", "false");
        }
      }, 200); // Adjust delay as needed (e.g., 150-300ms)
    });

    // ⌨️ Keyboard accessibility: Close on Escape key press or focusout
    if (!summary.closest("header-drawer")) { // Assuming header-drawer might have its own escape logic
      details.addEventListener("keyup", (event) => {
        if (event.key === "Escape") {
          if (details.closeTimeout) { // Clear timeout if closing via Escape
            clearTimeout(details.closeTimeout);
          }
          details.removeAttribute("open");
          summary.setAttribute("aria-expanded", "false");
        }
      });

      // Close on focusout (when tabbing away from the details element or its content)
      details.addEventListener("focusout", (event) => {
        // Check if the new focus target is outside the current details element
        if (!details.contains(event.relatedTarget)) {
          if (details.closeTimeout) { // Clear timeout if closing via focusout
            clearTimeout(details.closeTimeout);
          }
          details.removeAttribute("open");
          summary.setAttribute("aria-expanded", "false");
        }
      });
    }
    }

  });

} else {
  // --- MOBILE CODE ---
  document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
    summary.setAttribute('role', 'button');
    summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));
    if(summary.nextElementSibling?.getAttribute('id')) {
      summary.setAttribute('aria-controls', summary.nextElementSibling.id);
    }

    summary.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    if (summary.closest('header-drawer')) return;
    summary.parentElement.addEventListener('keyup', onKeyUpEscape);
  });
}

// CSS to ensure pointer-events are not blocking the summary or content if accidentally set to 'none'
// This is a general safeguard. If you have specific elements with pointer-events: none,
// you might need to target them more precisely.
const style = document.createElement('style');
style.textContent = `
  [id^="Details-"] summary,
  [id^="Details-"] > *:not(summary) {
    pointer-events: auto !important; /* Ensure summary and content are clickable/interactive */
  }
`;
document.head.appendChild(style);



  // Escape key support



const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== "TAB") return;
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first?.focus();
    }

    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last?.focus();
    }
  };

  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === "INPUT" &&
    ["search", "text", "email", "url"].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

try {
  document.querySelector(":focus-visible");
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    "ARROWUP",
    "ARROWDOWN",
    "ARROWLEFT",
    "ARROWRIGHT",
    "TAB",
    "ENTER",
    "SPACE",
    "ESCAPE",
    "HOME",
    "END",
    "PAGEUP",
    "PAGEDOWN",
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener("keydown", (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener("mousedown", () => {
    mouseClick = true;
  });

  window.addEventListener(
    "focus",
    () => {
      if (currentFocusedElement)
        currentFocusedElement.classList.remove("focused");

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add("focused");
    },
    true
  );
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);
  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== "ESCAPE") return;

  const openDetailsElement = event.target.closest("details[open]");
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector("summary");
  openDetailsElement.removeAttribute("open");
  summaryElement.setAttribute("aria-expanded", false);
  summaryElement.focus();
}

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  };
}

if (typeof window.Shopify == "undefined") {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent("on" + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options["method"] || "post";
  var params = options["parameters"] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (
  country_domid,
  province_domid,
  options
) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(
    options["hideElement"] || province_domid
  );

  Shopify.addListener(
    this.countryEl,
    "change",
    Shopify.bind(this.countryHandler, this)
  );

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute("data-default");
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function () {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute("data-provinces");
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = "none";
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement("option");
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement("option");
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector("details");

    this.addEventListener("keyup", this.onKeyUp.bind(this));
    this.addEventListener("focusout", this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll("summary").forEach((summary) =>
      summary.addEventListener("click", this.onSummaryClick.bind(this))
    );
    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onCloseButtonClick.bind(this))
    );
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== "ESCAPE") return;

    const openDetailsElement = event.target.closest("details[open]");
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(
          event,
          this.mainDetailsToggle.querySelector("summary")
        )
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest(".has-submenu");
    const isOpen = detailsElement.hasAttribute("open");
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(
        summaryElement.nextElementSibling,
        detailsElement.querySelector("button")
      );
      summaryElement.nextElementSibling.removeEventListener(
        "transitionend",
        addTrapFocus
      );
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen
        ? this.closeMenuDrawer(event, summaryElement)
        : this.openMenuDrawer(summaryElement);

      if (window.matchMedia("(max-width: 990px)")) {
        document.documentElement.style.setProperty(
          "--viewport-height",
          `${window.innerHeight}px`
        );
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add("menu-opening");
        summaryElement.setAttribute("aria-expanded", true);
        parentMenuElement && parentMenuElement.classList.add("submenu-open");
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener(
              "transitionend",
              addTrapFocus
            );
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });
    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove("menu-opening");
    this.mainDetailsToggle.querySelectorAll("details").forEach((details) => {
      details.removeAttribute("open");
      details.classList.remove("menu-opening");
    });
    this.mainDetailsToggle
      .querySelectorAll(".submenu-open")
      .forEach((submenu) => {
        submenu.classList.remove("submenu-open");
      });
    document.body.classList.remove(
      `overflow-hidden-${this.dataset.breakpoint}`
    );
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
  }

  onFocusOut() {
    setTimeout(() => {
      if (
        this.mainDetailsToggle.hasAttribute("open") &&
        !this.mainDetailsToggle.contains(document.activeElement)
      )
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest("details");
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest(".submenu-open");
    parentMenuElement && parentMenuElement.classList.remove("submenu-open");
    detailsElement.classList.remove("menu-opening");
    detailsElement
      .querySelector("summary")
      .setAttribute("aria-expanded", false);
    removeTrapFocus(detailsElement.querySelector("summary"));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute("open");
        if (detailsElement.closest("details[open]")) {
          trapFocus(
            detailsElement.closest("details[open]"),
            detailsElement.querySelector("summary")
          );
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define("menu-drawer", MenuDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      "click",
      this.hide.bind(this, false)
    );
    this.addEventListener("keyup", (event) => {
      if (event.code.toUpperCase() === "ESCAPE") this.hide();
    });
    if (this.classList.contains("media-modal")) {
      this.addEventListener("pointerup", (event) => {
        if (
          event.pointerType === "mouse" &&
          !event.target.closest("deferred-media, product-model")
        )
          this.hide();
      });
    } else {
      this.addEventListener("click", (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    
    this.openedBy = opener;
    const popup = this.querySelector(".template-popup");
    document.body.classList.add("overflow-hidden");
    this.setAttribute("open", "");
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove("overflow-hidden");
    document.body.dispatchEvent(new CustomEvent("modalClosed"));
    this.removeAttribute("open");
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define("modal-dialog", ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector("button");

    if (!button) return;
    button.addEventListener("click", () => {
      const modal = document.querySelector(this.getAttribute("data-modal"));
      if (modal) modal.show(button);
    });
  }
}
customElements.define("modal-opener", ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener("click", this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute("loaded")) {
      const content = document.createElement("div");
      content.appendChild(
        this.querySelector("template").content.firstElementChild.cloneNode(true)
      );

      this.setAttribute("loaded", true);
      const deferredElement = this.appendChild(
        content.querySelector("video, model-viewer, iframe")
      );
      if (focus) deferredElement.focus();
      if (
        deferredElement.nodeName == "VIDEO" &&
        deferredElement.getAttribute("autoplay")
      ) {
        deferredElement.play();
      }
    }
  }
}

customElements.define("deferred-media", DeferredMedia);

document.addEventListener("DOMContentLoaded", function () {
  let lastScrollTop = 0;
  const filterSortWrapper = document.querySelector(".filter-count");
  const filterOptionsAside = document.querySelector(".bls__canvas");
  const header = document.querySelector("header"); // Adjust this selector if needed

  window.addEventListener("scroll", function () {
    if (window.innerWidth <= 1024) {
      let scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if(filterSortWrapper !== null){
        if (scrollTop > lastScrollTop) {
          filterSortWrapper.style.position = "sticky";
          filterSortWrapper.style.top = "0";
        } else {
          filterSortWrapper.style.position = "sticky";
          filterSortWrapper.style.top = "65px";
        }
      }


      if (filterOptionsAside) {
        if (scrollTop > lastScrollTop) {
          filterOptionsAside.style.position = "fixed";
          filterOptionsAside.style.top = "0";
        } else {
          filterOptionsAside.style.position = "fixed";
          filterOptionsAside.style.top = "65px";
        }
      }

      lastScrollTop = scrollTop <= 0 ? 0 : scrollTop;
    } else {
        if(filterSortWrapper !== null){
          filterSortWrapper.style.position = "";
          filterSortWrapper.style.top = "";
        }
      if (filterOptionsAside) {
        filterOptionsAside.style.position = "";
        filterOptionsAside.style.top = "";
      }
    }
  });
}); document.addEventListener('DOMContentLoaded', function() {
  const filterButton = document.getElementById('toggleExpressDeliveryFilter');

  // Ensure the button exists on the page
  if (filterButton) {
    // Get the tag handle from the data attribute
    const tagHandle = filterButton.dataset.tagHandle;

    // --- Function to update the button's class based on the current URL state ---
    function updateButtonAppearance() {
        if (!tagHandle) return; // Need tag handle to check state

        const currentUrl = new URL(window.location.href);
        // Split the current path into segments, filter out any empty ones
        const pathSegments = currentUrl.pathname.split('/').filter(segment => segment !== '');

        // Check if the tag handle exists anywhere in the path segments
        const isFilterActive = pathSegments.includes(tagHandle);

        // Add or remove the 'filter-active' class based on the state
        if (isFilterActive) {
            filterButton.classList.add('filter-active');
        } else {
            filterButton.classList.remove('filter-active');
        }
    }
    // ---------------------------------------------------------------------


    // --- Call the function ONCE when the page loads to set the initial color ---
    updateButtonAppearance();
    // ---------------------------------------------------------------------------


    // --- Add the click listener for the toggle action ---
    filterButton.addEventListener('click', function() {
      // Get current state based on the URL *before* we change it
      const currentUrl = new URL(window.location.href);
      const pathSegments = currentUrl.pathname.split('/').filter(segment => segment !== '');
      const isFilterActive = pathSegments.includes(tagHandle); // Determine current state


      let newPathname;

      if (isFilterActive) {
        // Filter is currently active, so clicking should remove the tag from the URL path.
        const newPathSegments = pathSegments.filter(segment => segment !== tagHandle);
        newPathname = '/' + newPathSegments.join('/');
         if (newPathname === '//') newPathname = '/'; // Clean up root path

      } else {
        // Filter is not active, so clicking should add the tag to the URL path.
         newPathname = currentUrl.pathname;
         if (!newPathname.endsWith('/') && newPathname !== '/') {
            newPathname += '/';
         }
         newPathname += tagHandle;
      }

      // Create the new URL object with the modified pathname
      const newUrl = new URL(newPathname, window.location.origin);

      // Copy all existing query parameters (like ?sort_by=...) to the new URL
      currentUrl.searchParams.forEach((value, key) => {
          newUrl.searchParams.set(key, value);
      });
      filterButton.classList.toggle('filter-active');
      // -----------------------------------------------------------------------

      // Navigate to the new URL. This triggers a full page reload.
      window.location.href = newUrl.toString();

    }); // End of button click listener
  }
}); // End of DOMContentLoaded
function redirectToBannerLink(link) {
  if (link) { // Check if the link is not empty
    window.location.href = link; // Redirect to the provided link
    // Or, to open in a new tab:
    // window.open(link, '_blank');
  } else {
    console.log("No banner link provided for this slide.");
    // You could also add a fallback or do nothing if no link is set
  }
}